<!-- 报表下载 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        v-loading="deviceListLoading"
        element-loading-text="加载设备列表中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="meter-report"
        shadow="never"
      >
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.lb')">
              <el-button-group>
                <el-button :type="queryParams.dateType === 'day' ? 'primary' : ''" @click="handleDateTypeChange('day')">{{ $t('text.r') }}</el-button>
                <el-button :type="queryParams.dateType === 'month' ? 'primary' : ''" @click="handleDateTypeChange('month')">{{ $t('text.y') }}</el-button>
                <el-button :type="queryParams.dateType === 'year' ? 'primary' : ''" @click="handleDateTypeChange('year')">{{ $t('text.n') }}</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item :label="$t('text.shijian')">
              <el-date-picker
                v-show="queryParams.dateType === 'day'"
                v-model="queryParams.time"
                style="margin-top: 0;"
                type="date"
              />
              <el-date-picker
                v-show="queryParams.dateType === 'month'"
                v-model="queryParams.time"
                style="margin-top: 0;"
                type="month"
              />
              <el-date-picker
                v-show="queryParams.dateType === 'year'"
                v-model="queryParams.time"
                style="margin-top: 0;"
                type="year"
              />
            </el-form-item>
            <el-form-item label="电表号">
              <el-select v-model="queryParams.deviceId" clearable>
                <el-option
                  v-for="(item, index) in deviceList"
                  :key="index"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否乘以倍率">
              <el-select v-model="queryParams.isMultiplyByTheMultiplier">
                <el-option label="乘以倍率" :value="true" />
                <el-option label="未乘倍率" :value="false" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-video-play"
                type="primary"
                :loading="queryLoading || reportLoading"
                @click="handleQuery"
              >{{ $t('button.yl') }}</el-button>
              <el-button
                icon="el-icon-download"
                type="primary"
                :loading="queryLoading || reportLoading"
                @click="handleExport"
              >{{ $t('button.dc') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div
            v-loading="queryLoading || reportLoading"
            class="main-container"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <el-card v-if="hasQuery" class="top-overview" shadow="never">
              <div slot="header">
                {{ $t('text.gailan') }}
              </div>
              <div class="item-result">
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.sharp"
                  :title="$t('text.zxjs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.peak"
                  :title="$t('text.zxfs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.flat"
                  :title="$t('text.zxps')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.valley"
                  :title="$t('text.zxgs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.dvalley"
                  :title="$t('text.fdvlley')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.fenergy.total"
                  :title="$t('text.zxzdl')"
                  suffix="kWh"
                />
              </div>
              <div class="item-result">
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.sharp"
                  :title="$t('text.fxjs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.peak"
                  :title="$t('text.fxfs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.flat"
                  :title="$t('text.fxps')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.valley"
                  :title="$t('text.fxgs')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.dvalley"
                  :title="$t('text.rdvlley')"
                  suffix="kWh"
                />
                <el-statistic
                  group-separator=","
                  :precision="2"
                  :value="queryResponse.renergy.total"
                  :title="$t('text.fxzdl')"
                  suffix="kWh"
                />
              </div>
            </el-card>
            <div v-if="hasQuery" class="detail-container">
              <el-card v-if="queryParams.dateType === 'day'" class="bottom-overview__day" shadow="never">
                <template slot="header">
                  {{ $t('text.mx') }}
                  <span style="margin-left: 10px;color:red;">当读取不到电表读数时默认显示N/A</span>
                </template>
                <template slot="default">
                  <el-table :data="tableDetail.day" height="100%">
                    <el-table-column label="电表号" align="center" prop="sn" width="160" />
                    <el-table-column label="更新时间" align="center" prop="createtime" width="160" :formatter="formatTime" />
                    <el-table-column label="有功功率" align="center" prop="pac" :formatter="formatNumber" />
                    <el-table-column label="无功功率" align="center" prop="prc" :formatter="formatNumber" />
                    <el-table-column label="总功率因数" align="center" prop="fac" :formatter="formatNumber" />
                    <el-table-column label="正向尖电量" align="center" prop="fsharp" :formatter="formatNumber" />
                    <el-table-column label="正向峰电量" align="center" prop="fpeak" :formatter="formatNumber" />
                    <el-table-column label="正向平电量" align="center" prop="fflat" :formatter="formatNumber" />
                    <el-table-column label="正向谷电量" align="center" prop="fvalley" :formatter="formatNumber" />
                    <el-table-column label="正向总电量" align="center" prop="ftotal" :formatter="formatNumber" />
                    <el-table-column label="反向尖电量" align="center" prop="rsharp" :formatter="formatNumber" />
                    <el-table-column label="反向峰电量" align="center" prop="rpeak" :formatter="formatNumber" />
                    <el-table-column label="反向平电量" align="center" prop="rflat" :formatter="formatNumber" />
                    <el-table-column label="反向谷电量" align="center" prop="rvalley" :formatter="formatNumber" />
                    <el-table-column label="反向总电量" align="center" prop="rtotal" :formatter="formatNumber" />
                  </el-table>
                </template>
              </el-card>
              <el-card v-else-if="queryParams.dateType === 'month'" class="bottom-overview__month" shadow="never">
                <template slot="header">
                  {{ $t('text.mx') }}
                  <el-table :data="tableDetail.monthFirstAndLast" size="small">
                    <el-table-column label="数据描述" align="center" prop="dataDesc" width="200" />
                    <el-table-column label="更新时间" align="center" prop="createtime" width="165" :formatter="formateMonthTableTime" />
                    <el-table-column label="正向尖读数" align="center" prop="fsharp" :formatter="formatNumber" />
                    <el-table-column label="正向峰读数" align="center" prop="fpeak" :formatter="formatNumber" />
                    <el-table-column label="正向平读数" align="center" prop="fflat" :formatter="formatNumber" />
                    <el-table-column label="正向谷读数" align="center" prop="fvalley" :formatter="formatNumber" />
                    <el-table-column label="正向总读数" align="center" prop="ftotal" :formatter="formatNumber" />
                    <el-table-column label="反向尖读数" align="center" prop="rsharp" :formatter="formatNumber" />
                    <el-table-column label="反向峰读数" align="center" prop="rpeak" :formatter="formatNumber" />
                    <el-table-column label="反向平读数" align="center" prop="rflat" :formatter="formatNumber" />
                    <el-table-column label="反向谷读数" align="center" prop="rvalley" :formatter="formatNumber" />
                    <el-table-column label="反向总读数" align="center" prop="rtotal" :formatter="formatNumber" />
                  </el-table>
                </template>
                <template slot="default">
                  <el-table :data="tableDetail.month" height="100%">
                    <el-table-column label="更新时间" align="center" prop="dm" width="100" :formatter="formatTime" />
                    <el-table-column label="正向尖电量" align="center" prop="fsharp" :formatter="formatNumber" />
                    <el-table-column label="正向峰电量" align="center" prop="fpeak" :formatter="formatNumber" />
                    <el-table-column label="正向平电量" align="center" prop="fflat" :formatter="formatNumber" />
                    <el-table-column label="正向谷电量" align="center" prop="fvalley" :formatter="formatNumber" />
                    <el-table-column label="正向总电量" align="center" prop="ftotal" :formatter="formatNumber" />
                    <el-table-column label="反向尖电量" align="center" prop="rsharp" :formatter="formatNumber" />
                    <el-table-column label="反向峰电量" align="center" prop="rpeak" :formatter="formatNumber" />
                    <el-table-column label="反向平电量" align="center" prop="rflat" :formatter="formatNumber" />
                    <el-table-column label="反向谷电量" align="center" prop="rvalley" :formatter="formatNumber" />
                    <el-table-column label="反向总电量" align="center" prop="rtotal" :formatter="formatNumber" />
                  </el-table>
                </template>
              </el-card>
              <el-card v-else-if="queryParams.dateType === 'year'" class="bottom-overview__year" shadow="never">
                <template slot="header">
                  {{ $t('text.mx') }}
                </template>
                <template slot="default">
                  <el-table :data="tableDetail.year" height="100%">
                    <el-table-column label="更新时间" align="center" prop="dm" width="100" :formatter="formatTime" />
                    <el-table-column label="正向尖电量" align="center" prop="fsharp" :formatter="formatNumber" />
                    <el-table-column label="正向峰电量" align="center" prop="fpeak" :formatter="formatNumber" />
                    <el-table-column label="正向平电量" align="center" prop="fflat" :formatter="formatNumber" />
                    <el-table-column label="正向谷电量" align="center" prop="fvalley" :formatter="formatNumber" />
                    <el-table-column label="正向总电量" align="center" prop="ftotal" :formatter="formatNumber" />
                    <el-table-column label="反向尖电量" align="center" prop="rsharp" :formatter="formatNumber" />
                    <el-table-column label="反向峰电量" align="center" prop="rpeak" :formatter="formatNumber" />
                    <el-table-column label="反向平电量" align="center" prop="rflat" :formatter="formatNumber" />
                    <el-table-column label="反向谷电量" align="center" prop="rvalley" :formatter="formatNumber" />
                    <el-table-column label="反向总电量" align="center" prop="rtotal" :formatter="formatNumber" />
                  </el-table>
                </template>
              </el-card>
            </div>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetMeterReportData, ExpMeterReport } from '@/api/Meter'
import { GetDevicesByOrgId } from '@/api/Universal'
const dayjs = require('dayjs')
export default {
  components: {},
  data () {
    return {

      /** 设备列表加载中 */
      deviceListLoading: false,
      /** 设备列表 */
      deviceList: [],

      /** 查询加载中 */
      queryLoading: false,
      /** 是否有查询 */
      hasQuery: false,
      /** 查询参数 */
      queryParams: {
        /** 查询时间类型 */
        dateType: 'day',
        /** 查询时间 */
        time: new Date(),
        /** 设备ID */
        deviceId: '',
        /** 是否乘以倍率 */
        isMultiplyByTheMultiplier: true,
      },

      /** 查询响应 */
      queryResponse: {
        /** 详情 */
        details: [],
        /** 设备信息 */
        device: {},
        /** 正向电量 */
        fenergy: {
          sharp: 0,
          peak: 0,
          flat: 0,
          valley: 0,
          dvalley: 0,
          total: 0,
        },
        /** 反向电量 */
        renergy: {
          sharp: 0,
          peak: 0,
          flat: 0,
          valley: 0,
          dvalley: 0,
          total: 0,
        },
        /** 月份第1条历史数据 */
        monthFirst: '',
        /** 月份最后1条历史数据 */
        monthLast: '',
      },
      /** 查询结果 */
      tableDetail: {
        day: [],
        month: [],
        monthFirstAndLast: [],
        year: [],
      },

      /** 报告加载中 */
      reportLoading: false,

      /** 时间格式化配置 */
      formatTimeConfig: {
        day: 'YYYY-MM-DD HH:mm:ss',
        month: 'YYYY-MM-DD',
        year: 'YYYY',
      }
    }
  },
  mounted () {
    this.getDeviceList().then(() => {
      this.handleQuery()
    })
  },
  methods: {

    /** 格式化时间 */
    formatTime (_row, _column, cellValue, _index) {
      return dayjs(cellValue).format(this.formatTimeConfig[this.queryParams.dateType])
    },

    /** 格式化月份第1条和最后1条历史数据时间 */
    formateMonthTableTime (_row, _column, cellValue, _index) {
      return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
    },

    /** 格式化数字 */
    formatNumber (_row, _column, cellValue, _index) {
      return cellValue < 0 ? 'N/A' : cellValue.toFixed(2)
    },

    /** 获取设备列表 */
    getDeviceList () {
      this.deviceListLoading = true
      return new Promise((resolve, reject) => {
        GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' })
          .then(res => {
            this.deviceList = res.data || []
            this.queryParams.deviceId = this.deviceList[0].value || null
            resolve()
          }).catch(() => {
            this.$message({
              message: '获取设备列表失败',
              type: 'error'
            })
            reject()
          }).finally(() => {
            this.deviceListLoading = false
          })
      })
    },

    /** 查询时间类型改变 */
    handleDateTypeChange (dateType) {
      this.hasQuery = false
      this.queryParams.dateType = dateType
    },

    /** 预览 */
    handleQuery () {
      const startTime = dayjs(this.queryParams.time).startOf(this.queryParams.dateType).format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs(this.queryParams.time).endOf(this.queryParams.dateType).format('YYYY-MM-DD HH:mm:ss')
      const postData = {
        dateType: this.queryParams.dateType,
        startTime: startTime,
        endTime: endTime,
        orgId: this.$store.getters.station.id,
        deviceId: this.queryParams.deviceId,
        isMultiplyByTheMultiplier: this.queryParams.isMultiplyByTheMultiplier
      }
      this.queryLoading = true
      GetMeterReportData(postData).then(({ data }) => {
        this.queryResponse = data
      }).then(() => {
        if (this.queryParams.dateType === 'day') {
          this.tableDetail.day = this.queryResponse.details
        } else if (this.queryParams.dateType === 'month') {
          this.tableDetail.month = this.queryResponse.details
          this.queryResponse.monthFirst['dataDesc'] = dayjs(this.queryResponse.time).format('YYYY-MM') + '月份第1条历史数据'
          this.queryResponse.monthLast['dataDesc'] = dayjs(this.queryResponse.time).format('YYYY-MM') + '月份最后1条历史数据'
          this.tableDetail.monthFirstAndLast = [this.queryResponse.monthFirst, this.queryResponse.monthLast]
        } else if (this.queryParams.dateType === 'year') {
          this.tableDetail.year = this.queryResponse.details
        }
      }).then(() => {
        this.hasQuery = true
      }).catch(() => {
        this.$message({
          message: '查询失败',
          type: 'error'
        })
      }).finally(() => {
        this.queryLoading = false
      })
    },

    /** 导出 */
    handleExport () {
      const startTime = dayjs(this.queryParams.time).startOf(this.queryParams.dateType).format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs(this.queryParams.time).endOf(this.queryParams.dateType).format('YYYY-MM-DD HH:mm:ss')
      const postData = {
        dateType: this.queryParams.dateType,
        startTime: startTime,
        endTime: endTime,
        orgId: this.$store.getters.station.id,
        deviceId: this.queryParams.deviceId,
        isMultiplyByTheMultiplier: this.queryParams.isMultiplyByTheMultiplier
      }
      this.reportLoading = true
      ExpMeterReport(postData)
        .then(res => {
          window.location.href = res.data
        })
        .catch(() => {
          this.$message({
            message: '导出失败',
            type: 'error'
          })
        })
        .finally(() => {
          this.reportLoading = false
        })
    }
  },
}
</script>
<style scoped>
.meter-report {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.meter-report>>>.el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}
.meter-report>>>.el-card__header .el-form {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-report>>>.el-card__header .el-form .el-form-item {
  margin-bottom: 0;
}

.meter-report>>>.el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  box-sizing: border-box;
}

.meter-report>>>.el-card__body .main-container{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.meter-report>>>.el-card__body .main-container .top-overview{
  width: 100%;
  height: 200px;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.meter-report>>>.el-card__body .main-container .top-overview .el-card__header{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: white;
}
.meter-report>>>.el-card__body .main-container .top-overview .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
}
.meter-report>>>.el-card__body .main-container .top-overview .el-card__body .item-result{
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: flex-start;
}
.meter-report>>>.el-card__body .main-container .top-overview .el-card__body .item-result .el-statistic .head,
.meter-report>>>.el-card__body .main-container .top-overview .el-card__body .item-result .el-statistic .con{
  color: white;
}

.meter-report>>>.el-card__body .main-container .detail-container{
  width: 100%;
  height: calc(100% - 200px);
  padding: 0;
  box-sizing: border-box;
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__day{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__day .el-card__header{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: white;
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__day .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 15px;
  box-sizing: border-box;
}

.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__month{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__month .el-card__header{
  width: 100%;
  height: 150px;
  display: grid;
  grid-template-rows: 20px auto;
  align-items: flex-start;
  color: white;
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__month .el-card__body{
  width: 100%;
  height: calc(100% - 150px);
  padding: 0 15px;
  box-sizing: border-box;
}

.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__year{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__year .el-card__header{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: white;
}
.meter-report>>>.el-card__body .main-container .detail-container .bottom-overview__year .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 15px;
  box-sizing: border-box;
}
</style>
